export enum AlternateDonationOptions {
    KidneyPairedDonation = 1,
    AdvancedDonation = 2,
    GoodSamaritanDonation = 4,
    FindSomeoneElse = 8,
    FamilyVoucher = 16
}
